// Redux/Reducers/savedCardReducer.js
import {
  SAVED_CARD_FETCH_REQUEST,
  SAVED_CARD_FETCH_SUCCESS,
  SAVED_CARD_FETCH_FAIL,
  SAVED_CARD_DELETE_REQUEST,
  SAVED_CARD_DELETE_SUCCESS,
  SAVED_CARD_DELETE_FAIL,
  SAVED_CARD_CLEAR,
} from '../Constants/savedCardConstants';

export const savedCardReducer = (
  state = { savedCard: null, loading: false, error: null },
  action
) => {
  switch (action.type) {
    case SAVED_CARD_FETCH_REQUEST:
    case SAVED_CARD_DELETE_REQUEST:
      return { ...state, loading: true, error: null };

    case SAVED_CARD_FETCH_SUCCESS:
      return { loading: false, savedCard: action.payload, error: null };

    case SAVED_CARD_DELETE_SUCCESS:
    case SAVED_CARD_CLEAR:
      return { loading: false, savedCard: null, error: null };

    case SAVED_CARD_FETCH_FAIL:
    case SAVED_CARD_DELETE_FAIL:
      return { ...state, loading: false, error: action.payload };

    default:
      return state;
  }
};